module.exports = __webpack_public_path__ + "img/Papathanasiou.f5dfb44d.jpg";